import React, { useEffect, useState } from 'react';
import { Container, Row, Col, ListGroup } from 'react-bootstrap';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { postBuddyPressProfileTag, searchProfileTerms } from '../services';

const AddNewTag = ({ handleTagUpdate, listTags, group }) => {
  //const [curTags, setCurTags] = useState([]);
  const [list, setList] = useState([]);
  const [isLoading, SetisLoading] = useState(false);
  const [curSelect, setCurSelect] = useState([]);

  useEffect(() => {
    setList(list.map((t) => ({ label: t, value: t })));
  }, [listTags]);

  const handleInputChange = (inputValue) => {
    return new Promise((resolve) => {
      resolve(
        searchProfileTerms(group, inputValue).then((res) => {
          if (res.status === 200 && res.length) {
            const opt = res
              .filter((t) => listTags.indexOf(t) === -1)
              .map((t) => ({
                label: t.tag_name,
                value: t.id,
              }));

            return opt;
          }
        })
      );
    });
  };

  const handleChange = (newValue, actionMeta) => {
    const actions = {
      'remove-value': 'remove',
      'select-option': 'add',
      'create-option': 'add',
    };
    if (actionMeta.action) {
      let tags = [];
      const action = actions[actionMeta.action];
      if (
        action === 'add' &&
        listTags.indexOf(actionMeta.option.label) === -1
      ) {
        tags = [actionMeta.option.label]; //tags.filter((t) => curSelect.indexOf(t) === -1);
      } else if (action === 'remove') {
        tags = [actionMeta.removedValue.label];
      }
      if (tags && tags.length) {
        postBuddyPressProfileTag(action, 'group', tags).then((res) => {
          if (res.status === 200) {
            handleTagUpdate(action, [...tags]);
          }
        });
      }
      if (newValue && newValue.length) {
        setCurSelect(newValue.map((t) => t.label));
      }
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: 200,
    }),
  };
  return (
    <Container>
      <Row>
        <Col lg={12}>
          <div className='d-flex float-end'>
            <AsyncCreatableSelect
              styles={customStyles}
              placeholder='Type input for suggestions'
              isMulti
              isLoading={isLoading}
              onChange={handleChange}
              loadOptions={handleInputChange}
              // onCreateOptions={options}
              allowCreateWhileLoading={true}
              escapeClearsValue={false}
              isClearable={false}
              theme={(theme) => ({
                ...theme,
                borderRadius: 0,
                colors: {
                  ...theme.colors,
                  primary75: '#9f173e',
                  primary: '#f7921a',
                },
              })}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AddNewTag;
